export default __webpack_public_path__ + "static/media/LO13.bbc44b0f.mp3";